import { Platform } from "quasar";

export const commonMixinConstants = {
  scrollAreaVisible: true,
  scrollAreaThumbStyle: {
    right: "4px",
    borderRadius: "5px",
    backgroundColor: "#b7b7b7",
    width: "5px",
    opacity: 1,
    zIndex: 9999,
  },
  scrollAreaBarStyle: {
    right: "2px",
    borderRadius: "9px",
    backgroundColor: "#e5e5e5",
    width: "9px",
    opacity: 1,
    zIndex: 9999,
  },
};

export const androidAppVersion = 8.6;
export const iosAppVersion = 8.6;

export const IFrameActions = {
  MAP_USER: "MAP_USER",
  LNS_LOADED: "LNS_LOADED",
  NAVIGATION: "NAVIGATION",
  AUTH_TOKEN_EXPIRED: "AUTH_TOKEN_EXPIRED",
  AUTH_TOKEN_ABSENT: "AUTH_TOKEN_ABSENT",
};

export const cordovaFirebaseConfig = {
  dev: {
    apiKey: "AIzaSyA0z48Rxm9KLA3XbJG_ae-bamqcWVUmzng",
    authDomain: "loyal-n-save-staging.firebaseapp.com",
    projectId: "loyal-n-save-staging",
    storageBucket: "loyal-n-save-staging.appspot.com",
    messagingSenderId: "584517737553",
    appId: Platform.is?.android
      ? "1:584517737553:android:f0c1de114234b748"
      : "1:584517737553:ios:0de2e77948e64e78",
    measurementId: "G-NCWXJ0S7KD",
  },
  prod: {
    apiKey: "AIzaSyCV78IgIvx_zecLWIDs2zmE1srqrytTwMc",
    authDomain: "loyal-n-save.firebaseio.com",
    projectId: "loyal-n-save",
    storageBucket: "loyal-n-save.appspot.com",
    messagingSenderId: "158067556607",
    appId: Platform.is?.android
      ? "1:158067556607:android:e43457721a87d8b5"
      : "1:158067556607:ios:b2192b0d4efaf8be",
    measurementId: "G-HH31ND6VFX",
  },
};

export const webFirebaseConfig = {
  dev: {
    apiKey: "AIzaSyBJyH75oSi_8dlav2Pz9ym48wIofsy-D7A",
    authDomain: "loyal-n-save-staging.firebaseapp.com",
    databaseURL: "https://loyal-n-save-staging.firebaseio.com",
    projectId: "loyal-n-save-staging",
    storageBucket: "loyal-n-save-staging.appspot.com",
    messagingSenderId: "584517737553",
    appId: "1:584517737553:web:35653740e6366ee0376c70",
  },
  prod: {
    apiKey: "AIzaSyBrgDvKF2l1T7w1U-Z_Ao1EzC4TcvpJGPg",
    authDomain: "loyal-n-save.firebaseapp.com",
    databaseURL: "https://loyal-n-save.firebaseio.com",
    projectId: "loyal-n-save",
    storageBucket: "loyal-n-save.appspot.com",
    messagingSenderId: "158067556607",
    appId: "1:158067556607:web:c4286380f20ad4cd104cca",
    measurementId: "G-MHEHMXGS7F",
  },
};
